import { useState } from "react";
import "./Auth.css";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const SignIn = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const checkAdminCredentials = async (email, password) => {
    try {
      const adminRef = collection(db, "adminLogin");
      const q = query(adminRef, where("email", "==", email.toLowerCase()));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const adminData = querySnapshot.docs[0].data();

        // ✅ Check if password matches
        if (adminData.password === password) { // 🚨 Store hashed passwords in production!
          console.log("✅ Admin authenticated:", adminData);
          return true;
        } else {
          console.log("❌ Incorrect admin password.");
          return false;
        }
      } else {
        console.log("❌ No admin account found.");
        return false;
      }
    } catch (error) {
      console.error("🔥 Error verifying admin:", error);
      return false;
    }
  };

  const formSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log("Attempting login for:", email.toLowerCase());

      // Authenticate user with Firebase Authentication
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email.toLowerCase(),
        password
      );

      console.log("✅ User authenticated:", userCredential.user.email);

      // Check if user is attempting to access admin features
      const currentUrl = window.location.pathname;
      const isAdminLoginAttempt = currentUrl.includes("admin");

      if (isAdminLoginAttempt) {
        // Only check admin credentials when logging into admin area
        const isAdmin = await checkAdminCredentials(email.toLowerCase(), password);
        
        if (isAdmin) {
          toast.success("🎉 Welcome back, Admin!");
          setTimeout(() => navigate("/admin/dashboard"), 1000);
        } else {
          toast.error("❌ You are not authorized as an admin.");
        }
      } else {
        // Regular user login - redirect to home or cart
        toast.success("🎉 Login successful!");
        
        // Check if there are items in local storage cart that need to be synchronized
        // You can add cart sync logic here if needed
        
        setTimeout(() => navigate("/"), 1000);
      }
    } catch (error) {
      console.error("Login error:", error.code, error.message);

      if (error.code === "auth/user-not-found") {
        toast.error("No account found with this email.");
      } else if (error.code === "auth/wrong-password") {
        toast.error("Incorrect password. Please try again.");
      } else if (error.code === "auth/too-many-requests") {
        toast.error("Too many failed attempts. Try again later.");
      } else {
        toast.error("Invalid credentials. Please check your email and password.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <main>
        <ToastContainer />
        <div className="signin">
          <div className="signin_logo">
            <a href="/">
              Motor Easy
            </a>
          </div>
          <div className="wrapper">
            <form onSubmit={formSubmit}>
              <h2>Sign In</h2>
              <div className="input-field">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <label>Enter your Email</label>
              </div>
              <p
                id="email"
                className="text-danger text-start"
                style={{ fontSize: "12px", display: "none" }}
              ></p>
              <div className="input-field">
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <label>Enter your Password</label>
              </div>
              <p
                id="password"
                className="text-danger text-start"
                style={{ fontSize: "12px", display: "none" }}
              ></p>
              <div className="forget">
                <label htmlFor="remember">
                  <input type="checkbox" id="remember" />
                  <p>Remember me</p>
                </label>
                <Link to="/forgot-password" className="text-primary">
                  Forgot password?
                </Link>
              </div>
              <button type="submit" className="mt-4">
                {loading ? "Signing...." : "Sign In"}
              </button>
              <div className="register">
                <p>
                  Don't have an account?
                  <Link to="/Sign_up">
                    <b>Sign Up</b>
                  </Link>
                </p>
              </div>
              <div className="register w-100 d-flex justify-content-center">
                <Link to="/admin-login">
                  Login as admin
                </Link>
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
};